import { Flex, Text, useMantineTheme, Box } from "@mantine/core";
import { IEvents } from ".";
import { formatTime } from "src/utils/dateHelper";
import { useNavigate } from "react-router-dom";
import { ClientCardBg } from "src/utils/constants";

type IEventCart = {
  detail: IEvents[0];
};
export default function EventCard({ detail }: IEventCart) {
  const navigate = useNavigate();
  const { meeting } = detail;
  const theme = useMantineTheme();

  const bg = theme.colors[theme.colorScheme][1];
  const textColor = theme.colors.primaryTextColor[0];

  return (
    <>
      <Flex
        sx={{ borderRadius: 4 }}
        p={8}
        mt={"xs"}
        align={"center"}
        gap={"md"}
        onClick={() => navigate(`${meeting.id}`)}
        bg={theme.colors.primary[6]}
        style={{ color: theme.colors.primaryTextColor[6] }}
      >
        <Flex
          bg={theme.colors.primary[0]}
          direction={"column"}
          align={"center"}
          justify={"center"}
          p={8}
          sx={{ width: 55, height: 58, borderRadius: 50 }}
        >
          <Text size={14} color={textColor}>
            {formatTime(meeting.startAt).Hr_min}
          </Text>
          <Box
            sx={{
              borderBottom: `1px solid ${textColor}`,
              height: 1,
              width: 20,
            }}
          ></Box>

          <Text size={14} color={textColor}>
            {formatTime(meeting.endAt).Hr_min}
          </Text>
        </Flex>

        <Box>
          <Text size={14} fw={500}>
            {meeting.name}
          </Text>
          <Text size={14} color={textColor}>
            {meeting.location.name}
          </Text>
        </Box>
      </Flex>
    </>
  );
}
